import styled from 'styled-components'

export const ChartContainerWrapper = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
`
